export let NewsroomWebhook;
(function (_NewsroomWebhook) {
  let Event = /*#__PURE__*/function (Event) {
    Event["STORY_CREATED"] = "story.created";
    Event["STORY_UPDATED"] = "story.updated";
    Event["STORY_DELETED"] = "story.deleted";
    Event["CATEGORY_CREATED"] = "category.created";
    Event["CATEGORY_UPDATED"] = "category.updated";
    Event["CATEGORY_DELETED"] = "category.deleted";
    return Event;
  }({});
  _NewsroomWebhook.Event = Event;
})(NewsroomWebhook || (NewsroomWebhook = {}));